import { render, staticRenderFns } from "./ElError.vue?vue&type=template&id=71278ae6&scoped=true&"
import script from "./ElError.vue?vue&type=script&lang=js&"
export * from "./ElError.vue?vue&type=script&lang=js&"
import style0 from "./ElError.vue?vue&type=style&index=0&id=71278ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71278ae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71278ae6')) {
      api.createRecord('71278ae6', component.options)
    } else {
      api.reload('71278ae6', component.options)
    }
    module.hot.accept("./ElError.vue?vue&type=template&id=71278ae6&scoped=true&", function () {
      api.rerender('71278ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/forms/ElError.vue"
export default component.exports